import { render } from "./TaskCombineReportsMenuItem.vue?vue&type=template&id=3f0048bc"
import script from "./TaskCombineReportsMenuItem.vue?vue&type=script&lang=js"
export * from "./TaskCombineReportsMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/TaskCombineReportsMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f0048bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f0048bc', __exports__)) {
    console.log('reload')
    api.reload('3f0048bc', __exports__)
  }
  
  module.hot.accept("./TaskCombineReportsMenuItem.vue?vue&type=template&id=3f0048bc", () => {
    console.log('re-render')
    api.rerender('3f0048bc', render)
  })

}


export default __exports__